import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useStyleGuideContext } from '~/grid/context/StyleGuideContext';
import { getAutotagValue } from '~/grid/utils/styleGuideUtils';
import { ImageAsset } from '~/techstyle-shared/react-assets';
import {
  desktop,
  useProductFiltersCustomFilters,
} from '~/techstyle-shared/react-components';

const StyledAsset = styled(ImageAsset)``;

const selectedAssetStyle = css`
  border: 4px solid ${({ theme }) => theme.colors.palette.black};
`;

const StyledAssetWrapper = styled.button`
  background: none;
  padding: 0;
  border: 4px solid ${({ theme }) => theme.colors.styleGuideAssetWrapper};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  ${desktop`
    &:hover {
      ${selectedAssetStyle}
    }
  `}

  ${({ assetSelected }) => assetSelected && selectedAssetStyle}
`;

export default function StyleGuideAsset({ asset, tagList, handleOnLoad }) {
  const { setSelectedFilters, appliedFilters } =
    useProductFiltersCustomFilters();

  const { activeCategoryLabel } = useStyleGuideContext();

  const autotagValue = getAutotagValue({
    isImage: true,
    tagName: asset.options.customVars?.tag_name,
    activeCategoryLabel,
  });

  const assetSelected = appliedFilters?.aggregationFilter?.[tagList]?.includes(
    asset.options.customVars?.tag_name
  );

  const handleAssetSelected = () => {
    const { customVars } = asset.options;

    if (customVars) {
      const styleName = customVars.tag_name;
      const appliedStyleFilters = appliedFilters.aggregationFilter?.[tagList];

      if (styleName && !assetSelected) {
        setSelectedFilters((prevSelectedFilters) => ({
          ...prevSelectedFilters,
          aggregationFilter: {
            ...prevSelectedFilters.aggregationFilter,
            [tagList]: [
              styleName,
              ...(prevSelectedFilters.aggregationFilter?.[tagList] || []),
            ],
          },
        }));
      } else {
        const newlyAppliedStyleFilters = appliedStyleFilters?.filter(
          (selectedStyle) => selectedStyle !== styleName
        );
        setSelectedFilters((prevSelectedFilters) => ({
          ...prevSelectedFilters,
          aggregationFilter: {
            ...prevSelectedFilters.aggregationFilter,
            [tagList]: newlyAppliedStyleFilters,
          },
        }));
      }
    }
  };

  return (
    <StyledAssetWrapper
      data-testid={`asset-${asset.id}`}
      data-autotag={autotagValue}
      onClick={handleAssetSelected}
      assetSelected={assetSelected}
    >
      <StyledAsset
        asset={asset}
        assetSelected={assetSelected}
        handleOnLoad={handleOnLoad}
      />
    </StyledAssetWrapper>
  );
}

StyleGuideAsset.propTypes = {
  asset: PropTypes.any,
  handleOnLoad: PropTypes.func,
  tagList: PropTypes.string,
};
